import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveProjectState = createStateReducer(initialState, {
  [events.removeProjectSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeProject",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeProjectFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeProject",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveProjectState };
